import { gql } from '@apollo/client'

export const LIST_WEB_STORIES = gql`
  query AWebStory($input: listWebStoryInput) {
    listWebStoryFront(input: $input) {
      aWebStory {
        _id
        oCoverImg {
          sUrl
          sText
        }
        sTitle
        nPage
        oSeo {
          sSlug
        }
      }
    }
  }
`
export const GET_WEB_STORIES_DETAIL = gql`
  query GetWebStoryFront($input: getWebStoryFront) {
    getWebStoryFront(input: $input) {
      oAuthor {
        sFName
        sDisplayName
      }
      oDisplayAuthor {
        sFName
        sDisplayName
      }
      sBody
      sHead
      oProps
      aImg # For schema
      dUpdated #For schema
      dPublishDate #For schema
      sTitle #For schema
      oCoverImg { #For schema
        sUrl
      }
      # For custom stories
      bIsCustom
      aItems {
        sTitle
        sLinkText
        sLink
        sDescription
        sCredits
        oImg {
          sUrl
          sText
        }
        eType
      }
    }
  }
`
